import styled from 'styled-components';

export const ROIWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1% 3%;
    font-size: 1rem;
    align-items: flex-start;
    margin: 10px 0;
    padding-bottom: 50px;
    text-align: left;

    @media only screen and (max-width: 600px) {
        align-items: center;
        // width: 100%;
    }
`;

export const MessageTitle = styled.h2`
    font-size: 1rem;
    color: ${props => props.theme.evTeal};
    stroke: bold;
`;

export const MessageBody = styled.div`
    font-size: 1rem;
    text-align: left;
`;

export const SliderContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    margin: 20px 0;
    min-width: 400px;
    height: 75px;
    text-align: center;

    @media only screen and (max-width: 600px) {
        min-width: 100%;
    }
`;

// Advanced config styles

export const AdvancedConfig = styled.div`
    font-size: 1rem;
    color: ${props => props.theme.voltBlue};
    text-align: left;
    display: ${props => props.expanded ? 'block' : 'none'};

    p {
        margin: 0.5rem;
    }
`;

export const ExpanderButton = styled.button`
    display: flex;
    flex-direction: row;
    width: 125px;
    background: none;
    border: none;
    align-items: center;
    justify-content: space-between;
    font-size: 1rem;
    color: ${props => props.theme.evTeal};

    &:hover {
        cursor: pointer;
        // color: ${props => props.theme.voltBlue};
    }
`;

export const ExpanderText = styled.p`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    
    &:hover {
        cursor: pointer;
    }

    @media only screen and (max-width: 600px) {
        b {
            display: none;
        }
    }
`;

export const AdvancedConfigContainer = styled.div`
    display: ${props => props.expanded ? 'flex': 'none'};
    flex-direction: column;
    width: 100%;
    padding: 15px;
`;

export const QuestionContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 2fr;
    column-gap: 15px;
    width: 100%;
    min-width: 400px;
    height: 100%;
    margin-bottom: 20px;
    align-items: center;

    @media only screen and (max-width: 800px) {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        text-align: left;
        padding-bottom: 30px;
        border-bottom: 1px solid ${props => props.theme.voltBlue};
        min-width: 100%;
    }
`;

export const InputLabel = styled.p` 
    font-size: 1rem;
    color: ${props => props.theme.voltBlue};
    margin-left: 10px;
    vertical-align: middle;
    height: fit-content;
    align-self: center;

    @media only screen and (max-width: 800px) {
        margin: 5px;
        align-self: flex-start;
        justify-self: center;
        justify-content: center;

    }
`;

export const AddedRevenueSection = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const ChartContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: 20px 20px
    padding: 50px;
`;

export const InputUnit = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0;

    @media only screen and (max-width: 800px) {
        width: 75%;
        align-self: flex-start;
        height: 100%;
    }
`;